<template>
  <el-form
    :model="accessSplitForm"
    :rules="accessSplitRules"
    ref="accessSplitForm"
    label-width="160px"
    :inline-message="true"
    class="access-split-form rule-form"
  >
    <el-form-item prop="logExample" label="日志样例：">
      <el-input
        v-model="accessSplitForm.logExample"
        type="textarea"
        :autosize="{ minRows: 4 }"
        placeholder="请输入日志样例"
        :disabled="formType === 'SHOW'"
      ></el-input>
    </el-form-item>
    <div class="access-split-form-flex access-split-form-pattern">
      <el-form-item
        class="access-split-form-pattern-selsect"
        prop="delimiterSeparator"
        label="分隔符："
        :disabled="formType === 'SHOW'"
      >
        <el-select
          v-model="accessSplitForm.delimiterSeparator"
          placeholder="请选择分隔符"
          @change="onShowCustom"
          :disabled="formType === 'SHOW'"
        >
          <el-option
            v-for="(item, index) in separatorOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <transition name="fade">
        <el-form-item
          class="access-split-form-pattern-int"
          label-width="0"
          v-if="accessSplitForm.delimiterSeparator === 'customize'"
          prop="customize"
        >
          <el-input
            v-model="accessSplitForm.customize"
            placeholder="最多支持输入 3 个字符"
            maxlength="3"
            :disabled="formType === 'SHOW'"
          ></el-input>
        </el-form-item>
      </transition>
      <div class="pattern-btn">
        <el-button v-if="formType !== 'SHOW'" type="primary" @click="onParseSeparator"
          >测试</el-button
        >
      </div>
    </div>

    <div
      class="access-split-form-flex"
      v-for="(result, index) in accessSplitForm.results"
      :key="index"
    >
      <el-form-item
        class="access-split-form-flex-key"
        :class="{ 'form-tip-top': index === accessSplitForm.results.length - 1 }"
        :prop="`results[${index}].key`"
        :rules="accessSplitRules.results"
      >
        <span slot="label" v-if="index === 0"> 提取结果：</span>
        <el-input
          :title="result.key"
          v-model="result.key"
          :disabled="formType === 'SHOW'"
        ></el-input>
      </el-form-item>
      <el-form-item
        class="access-split-form-flex-int"
        :class="{ 'form-tip-top': index === accessSplitForm.results.length - 1 }"
        :prop="`results[${index}].value`"
        :rules="accessSplitRules.value"
        label-width="0"
      >
        <el-input :title="result.value" v-model="result.value" disabled></el-input>
      </el-form-item>
    </div>
    <el-form-item v-if="!!errorTip">
      <p class="error-tip">{{ errorTip }}</p>
    </el-form-item>
  </el-form>
</template>

<script>
import Validator from '../../../../utils/Validator';

export default {
  name: 'AccessSplitRuleCreator',

  props: {
    accessConfigForm: {
      type: Object
    },
    formType: {
      type: String
    }
  },

  data() {
    const validatorRequired = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.required()).validate();
    };

    const validatorStandardStr = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator
        .register(validator.isNoSpace())
        .register(validator.isStandardStr())
        .validate();
    };

    const validatorLength = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.lenRange(50)).validate();
    };

    const validatorRepeat = (rule, value, cb) => {
      if (this.onCheckRepeat()) {
        this.errorTip = 'key 不能重复';
        return;
      }
      this.errorTip = '';
      cb();
    };

    return {
      errorTip: '',
      separatorOptions: [
        {
          label: '逗号',
          value: ','
        },
        {
          label: '空格',
          value: ' '
        },
        {
          label: '自定义',
          value: 'customize'
        }
      ],
      accessSplitForm: {
        logExample: '',
        delimiterSeparator: '',
        customize: null,
        results: [
          {
            key: '',
            value: ''
          }
        ]
      },
      accessSplitRules: {
        logExample: [
          { required: true, message: '请输入日志样例', trigger: 'blur' },
          { validator: validatorRequired, message: '请输入日志样例', trigger: 'blur' }
        ],
        delimiterSeparator: {
          required: true,
          message: '请选择分隔符',
          trigger: 'change'
        },
        customize: { required: true, message: '请输入分隔符', trigger: 'blur' },
        results: [
          {
            required: true,
            message: 'key 不能为空',
            trigger: 'blur'
          },
          { validator: validatorRequired, message: 'key 不能为空', trigger: ['blur', 'change'] },
          { validator: validatorStandardStr, trigger: 'blur' },
          { validator: validatorLength, trigger: 'blur' },
          { validator: validatorRepeat, trigger: 'blur' }
        ],
        value: {
          validator: validatorRequired,
          message: 'value 不能为空',
          trigger: 'change'
        }
      },
      separator: null // 保存切割的参数
    };
  },

  created() {
    this.getData();
  },

  methods: {
    /**
     * 本地存储数据，用来步骤切换时回显数据
     */
    getData() {
      this.accessSplitForm = {
        logExample: this.accessConfigForm.logExample,
        delimiterSeparator:
          this.accessConfigForm.customize !== null
            ? 'customize'
            : this.accessConfigForm.delimiterSeparator,
        customize: this.accessConfigForm.customize,
        results: this.accessConfigForm.results
      };
    },
    onResetReault() {
      this.accessSplitForm.results = [
        {
          key: '',
          value: ''
        }
      ];
    },
    /**
     * 自定义分隔符
     */
    onShowCustom(val) {
      this.onResetReault();
      if (val === 'customize') {
        this.separator = this.accessSplitForm.customize;
      } else {
        this.accessSplitForm.customize = null;
      }
    },
    /**
     * 计算提取结果
     */
    onParseSeparator() {
      if (
        !this.accessSplitForm.logExample ||
        this.accessSplitForm.logExample.trim() === '' ||
        !this.accessSplitForm.delimiterSeparator
      ) {
        this.onResetReault();
        return;
      }

      // 用于解析日志样例
      let tempSplit;

      this.accessSplitForm.delimiterSeparator = tempSplit =
        this.accessSplitForm.delimiterSeparator === 'customize'
          ? this.accessSplitForm.customize
          : this.accessSplitForm.delimiterSeparator;

      // 如果是空格校验，转换为正则
      tempSplit = tempSplit === ' ' ? /\s+/ : tempSplit;

      // 分隔符和日志样例不能相同
      if (tempSplit === this.accessSplitForm.logExample.trim()) {
        this.onResetReault();
        return;
      }

      const tempResult = this.accessSplitForm.logExample.trim().split(tempSplit);

      this.accessSplitForm.results = tempResult.map(item => {
        return {
          key: '',
          value: item
        };
      });
    },
    onSaveData() {
      return this.accessSplitForm;
    },
    /**
     * 检查 key 值是否重复
     */
    onCheckRepeat() {
      const noRepeatArr = [
        ...new Set(this.accessSplitForm.results.map(result => JSON.stringify(result.key)))
      ];
      return noRepeatArr.length < this.accessSplitForm.results.length;
    },
    /**
     * 提交验证
     */
    onValidate() {
      if (this.onCheckRepeat()) {
        this.errorTip = 'key 不能重复';
        // 如果校验不通过，禁止父组件进行下一步操作
        return Promise.reject();
      }
      this.errorTip = '';
      return this.$refs.accessSplitForm.validate();
    }
  }
};
</script>

<style lang="scss" scoped>
.access-split-form {
  &-pattern {
    position: relative;

    .pattern-btn {
      position: absolute;
      top: 0;
      right: 0;
      transform: translateX(110%);
    }

    &-selsect {
      flex-shrink: 0;
      width: 55%;
      margin-right: 10px;
    }
  }

  &-flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;

    &-key {
      width: 60%;
      margin-right: 10px;
    }

    &-int {
      width: 40%;
    }
  }
}
</style>
